import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../../assets/img/logo-full.png";
import avatar from "../../assets/img/generic/avatar-placeholder.jpg";
import { useNavigate } from "react-router-dom";
import { useChat } from "../../context/ChatContext";
import { useChatModal } from "../ChatModal";
import { toast } from "react-toastify";
import NotificationDropdown from "../../pages/notification/NotificationDropdown";

function Navbar() {
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);

  const roleId = localStorage.getItem("roleId");

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  };

  const toggleSidebarVisibility = () => {
    document.querySelector("html").classList.toggle("sidebar-hidden");
  };

  const toggleFullScreenVisibility = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.error(
          `Error attempting to enable full-screen mode: ${err.message}`
        );
      });
    } else {
      document.exitFullscreen().catch((err) => {
        console.error(
          `Error attempting to exit full-screen mode: ${err.message}`
        );
      });
    }
  };

  const { toggleChat } = useChat();
  const { openModal } = useChatModal();

  const toggleSearch = () => {
    setIsSearchExpanded(!isSearchExpanded);
  };

  const handleStoreButtonClick = (e) => {
    e.preventDefault();
    toast.info("This feature is under development.");
  };

  return (
    <>
      {/* Custom CSS for profile picture gradient, icon hover animations, and basic styling */}
      <style>
        {`
          .navbar-static {
            background: #ffffff;
            box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          }

          .nav-icon-animated {
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;
          }

          .nav-icon-animated:hover {
            transform: scale(1.1);
            color: #ff6b6b !important;
          }

          .nav-icon-animated:hover::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
            animation: shine 1.5s ease;
          }

          @keyframes shine {
            0% { left: -100%; }
            100% { left: 100%; }
          }

          .nav-icon-pulse {
            animation: pulse 2s infinite;
          }

          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }

          .nav-icon-bounce {
            animation: bounce 3s infinite;
          }

          @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-2px); }
          }

          .nav-icon-wave {
            animation: wave 2s ease-in-out infinite;
          }

          @keyframes wave {
            0%, 100% { transform: rotate(0deg); }
            25% { transform: rotate(5deg); }
            75% { transform: rotate(-5deg); }
          }

          .user-avatar-glow {
            animation: avatarGlow 3s ease-in-out infinite;
          }

          @keyframes avatarGlow {
            0%, 100% { box-shadow: 0 0 5px rgba(255, 107, 107, 0.5); }
            50% { box-shadow: 0 0 15px rgba(255, 107, 107, 0.8); }
          }

          .ai-icon-glow {
            animation: glow 2s ease-in-out infinite alternate;
          }

          @keyframes glow {
            from { filter: drop-shadow(0 0 2px #ff6b6b); }
            to { filter: drop-shadow(0 0 6px #ff6b6b); }
          }

          .notification-badge {
            animation: heartbeat 1.5s ease-in-out infinite both;
          }

          @keyframes heartbeat {
            from { transform: scale(1); }
            10% { transform: scale(1.1); }
            20% { transform: scale(1); }
            30% { transform: scale(1.1); }
            40% { transform: scale(1); }
          }
        `}
      </style>

      <nav
        className="navbar navbar-top fixed-top navbar-expand navbar-static"
        id="navbarDefault"
      >
        <div className="collapse navbar-collapse justify-content-between">
          <div className="navbar-logo">
            <button
              className="btn navbar-toggler navbar-toggler-humburger-icon hover-bg-transparent"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarVerticalCollapse"
              aria-controls="navbarVerticalCollapse"
              aria-expanded="false"
              aria-label="Toggle Navigation"
            >
              <span className="navbar-toggle-icon">
                <span className="toggle-line"></span>
              </span>
            </button>

            <div className="d-flex gap-3">
              <div className="cursor-pointer" onClick={toggleSidebarVisibility}>
                <i className="fas fa-bars fs-6 lh-1 text-primary"></i>
              </div>
              <div
                className="cursor-pointer"
                onClick={toggleFullScreenVisibility}
              >
                <i className="fas fa-expand fs-6 lh-1 text-primary"></i>
              </div>
              {/* <div
                className="cursor-pointer nav-icon-animated nav-icon-pulse"
                onClick={toggleSearch}
              >
                <i className="fas fa-search fs-6 lh-1 text-primary"></i>
              </div> */}
            </div>
          </div>

          <div
            className={`search-box navbar-top-search-box ${
              isSearchExpanded ? "d-block" : "d-none"
            }`}
            data-list='{"valueNames":["title"]}'
            style={{ width: "25rem" }}
          >
            <form
              className="position-relative"
              data-bs-toggle="search"
              data-bs-display="static"
            >
              <input
                className="form-control search-input fuzzy-search rounded-pill form-control-sm border-primary"
                type="search"
                placeholder="Search..."
                aria-label="Search"
                style={{ borderWidth: "2px" }}
              />
              <span className="fas fa-search search-box-icon text-primary"></span>
            </form>
            <div
              className="btn-close position-absolute end-0 top-50 translate-middle cursor-pointer shadow-none"
              onClick={toggleSearch}
            >
              <button className="btn btn-link p-0" aria-label="Close"></button>
            </div>
            <div className="dropdown-menu border start-0 py-0 overflow-hidden w-100">
              <div className="scrollbar-overlay" style={{ maxHeight: "30rem" }}>
                <div className="list pb-3">
                  <h6 className="dropdown-header text-body-highlight fs-10 py-2">
                    24 <span className="text-body-quaternary">results</span>
                  </h6>
                  <hr className="my-0" />
                  <h6 className="dropdown-header text-body-highlight fs-9 border-bottom border-translucent py-2 lh-sm">
                    Recently Searched
                  </h6>
                  <div className="py-2">
                    <a
                      className="dropdown-item"
                      href="../apps/e-commerce/landing/product-details.html"
                    >
                      <div className="d-flex align-items-center">
                        <div className="fw-normal text-body-highlight title">
                          <span
                            className="fa-solid fa-clock-rotate-left"
                            data-fa-transform="shrink-2"
                          ></span>{" "}
                          Store Macbook
                        </div>
                      </div>
                    </a>
                    <a
                      className="dropdown-item"
                      href="../apps/e-commerce/landing/product-details.html"
                    >
                      <div className="d-flex align-items-center">
                        <div className="fw-normal text-body-highlight title">
                          <span
                            className="fa-solid fa-clock-rotate-left"
                            data-fa-transform="shrink-2"
                          ></span>{" "}
                          MacBook Air - 13″
                        </div>
                      </div>
                    </a>
                  </div>
                  <hr className="my-0" />
                  <h6 className="dropdown-header text-body-highlight fs-9 border-bottom border-translucent py-2 lh-sm">
                    Products
                  </h6>
                  <div className="py-2">
                    <a
                      className="dropdown-item py-2 d-flex align-items-center"
                      href="../apps/e-commerce/landing/product-details.html"
                    >
                      <div className="file-thumbnail me-2">
                        <img
                          className="h-100 w-100 object-fit-cover rounded-3"
                          src="../assets/img/products/60x60/3.png"
                          alt=""
                        />
                      </div>
                      <div className="flex-1">
                        <h6 className="mb-0 text-body-highlight title">
                          MacBook Air - 13″
                        </h6>
                        <p className="fs-10 mb-0 d-flex text-body-tertiary">
                          <span className="fw-medium text-body-tertiary text-opactity-85">
                            8GB Memory - 1.6GHz - 128GB Storage
                          </span>
                        </p>
                      </div>
                    </a>
                    <a
                      className="dropdown-item py-2 d-flex align-items-center"
                      href="../apps/e-commerce/landing/product-details.html"
                    >
                      <div className="file-thumbnail me-2">
                        <img
                          className="img-fluid"
                          src="../assets/img/products/60x60/3.png"
                          alt=""
                        />
                      </div>
                      <div className="flex-1">
                        <h6 className="mb-0 text-body-highlight title">
                          MacBook Pro - 13″
                        </h6>
                        <p className="fs-10 mb-0 d-flex text-body-tertiary">
                          <span className="fw-medium text-body-tertiary text-opactity-85">
                            30 Sep at 12:30 PM
                          </span>
                        </p>
                      </div>
                    </a>
                  </div>
                  <hr className="my-0" />
                  <h6 className="dropdown-header text-body-highlight fs-9 border-bottom border-translucent py-2 lh-sm">
                    Quick Links
                  </h6>
                  <div className="py-2">
                    <a
                      className="dropdown-item"
                      href="../apps/e-commerce/landing/product-details.html"
                    >
                      <div className="d-flex align-items-center">
                        <div className="fw-normal text-body-highlight title">
                          <span
                            className="fa-solid fa-link text-body"
                            data-fa-transform="shrink-2"
                          ></span>{" "}
                          Support MacBook House
                        </div>
                      </div>
                    </a>
                    <a
                      className="dropdown-item"
                      href="../apps/e-commerce/landing/product-details.html"
                    >
                      <div className="d-flex align-items-center">
                        <div className="fw-normal text-body-highlight title">
                          <span
                            className="fa-solid fa-link text-body"
                            data-fa-transform="shrink-2"
                          ></span>{" "}
                          Store MacBook″
                        </div>
                      </div>
                    </a>
                  </div>
                  <hr className="my-0" />
                  <h6 className="dropdown-header text-body-highlight fs-9 border-bottom border-translucent py-2 lh-sm">
                    Files
                  </h6>
                  <div className="py-2">
                    <a
                      className="dropdown-item"
                      href="../apps/e-commerce/landing/product-details.html"
                    >
                      <div className="d-flex align-items-center">
                        <div className="fw-normal text-body-highlight title">
                          <span
                            className="fa-solid fa-file-zipper text-body"
                            data-fa-transform="shrink-2"
                          ></span>{" "}
                          Library MacBook folder.rar
                        </div>
                      </div>
                    </a>
                    <a
                      className="dropdown-item"
                      href="../apps/e-commerce/landing/product-details.html"
                    >
                      <div className="d-flex align-items-center">
                        <div className="fw-normal text-body-highlight title">
                          <span
                            className="fa-solid fa-file-lines text-body"
                            data-fa-transform="shrink-2"
                          ></span>{" "}
                          Feature MacBook extensions.txt
                        </div>
                      </div>
                    </a>
                    <a
                      className="dropdown-item"
                      href="../apps/e-commerce/landing/product-details.html"
                    >
                      <div className="d-flex align-items-center">
                        <div className="fw-normal text-body-highlight title">
                          <span
                            className="fa-solid fa-image text-body"
                            data-fa-transform="shrink-2"
                          ></span>{" "}
                          MacBook Pro_13.jpg
                        </div>
                      </div>
                    </a>
                  </div>
                  <hr className="my-0" />
                  <h6 className="dropdown-header text-body-highlight fs-9 border-bottom border-translucent py-2 lh-sm">
                    Members
                  </h6>
                  <div className="py-2">
                    <a
                      className="dropdown-item py-2 d-flex align-items-center"
                      href="../pages/members.html"
                    >
                      <div className="avatar avatar-l status-online me-2 text-body">
                        <img
                          className="rounded-circle"
                          src={`${process.env.PUBLIC_URL}/image/team/1.jpg`}
                          alt=""
                        />
                      </div>
                      <div className="flex-1">
                        <h6 className="mb-0 text-body-highlight title">
                          Carry Anna
                        </h6>
                        <p className="fs-10 mb-0 d-flex text-body-tertiary">
                          anna@technext.it
                        </p>
                      </div>
                    </a>
                    <a
                      className="dropdown-item py-2 d-flex align-items-center"
                      href="../pages/members.html"
                    >
                      <div className="avatar avatar-l me-2 text-body">
                        <img
                          className="rounded-circle"
                          src={`${process.env.PUBLIC_URL}/image/team/1.jpg`}
                          alt=""
                        />
                      </div>
                      <div className="flex-1">
                        <h6 className="mb-0 text-body-highlight title">
                          John Smith
                        </h6>
                        <p className="fs-10 mb-0 d-flex text-body-tertiary">
                          smith@technext.it
                        </p>
                      </div>
                    </a>
                  </div>
                  <hr className="my-0" />
                  <h6 className="dropdown-header text-body-highlight fs-9 border-bottom border-translucent py-2 lh-sm">
                    Related Searches
                  </h6>
                  <div className="py-2">
                    <a
                      className="dropdown-item"
                      href="../apps/e-commerce/landing/product-details.html"
                    >
                      <div className="d-flex align-items-center">
                        <div className="fw-normal text-body-highlight title">
                          <span
                            className="fa-brands fa-firefox-browser text-body"
                            data-fa-transform="shrink-2"
                          ></span>{" "}
                          Search in the Web MacBook
                        </div>
                      </div>
                    </a>
                    <a
                      className="dropdown-item"
                      href="../apps/e-commerce/landing/product-details.html"
                    >
                      <div className="d-flex align-items-center">
                        <div className="fw-normal text-body-highlight title">
                          <span
                            className="fa-brands fa-chrome text-body"
                            data-fa-transform="shrink-2"
                          ></span>{" "}
                          Store MacBook″
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="text-center">
                  <p className="fallback fw-bold fs-7 d-none">
                    No Result Found.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <ul className="navbar-nav navbar-nav-icons flex-row gap-3">
            {roleId === "11" ? null : (
              <>
                <li className="nav-item">
                  <div className="d-flex gap-1">
                    <a
                      href="#"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={handleStoreButtonClick}
                    >
                      {/* <img
                        className="nav-icon-animated"
                        height="30px"
                        src={appStoreBtn}
                        alt="Get it on App Store"
                        style={{ transition: "all 0.3s ease" }}
                      /> */}
                    </a>
                    <a
                      href="#"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={handleStoreButtonClick}
                    >
                      {/* <img
                        className="nav-icon-animated"
                        height="30px"
                        src={googlePlayBtn}
                        alt="Get it on Google Play"
                        style={{ transition: "all 0.3s ease" }}
                      /> */}
                    </a>
                  </div>
                </li>
                {/* <li className="nav-item">
                  <div
                    className="chat-toggle-btn nav-icon-animated nav-icon-bounce"
                    role="button"
                    aria-label="Cart"
                  >
                    <span
                      className="fas fa-shopping-cart fs-6 lh-1 text-primary"
                      style={{ height: "20px", width: "20px" }}
                    ></span>
                  </div>
                </li> */}
                {/* <li className="nav-item">
                  <div
                    className="chat-toggle-btn nav-icon-animated nav-icon-wave"
                    role="button"
                    aria-label="Toggle chat"
                    onClick={toggleChat}
                  >
                    <span
                      className="fas fa-comments fs-6 lh-1 text-primary"
                      style={{ height: "20px", width: "20px" }}
                    ></span>
                  </div>
                </li> */}
              </>
            )}
            <li className="nav-item">
              <div
                className="cursor-pointer position-relative"
                role="button"
                aria-label="Ask AI"
                onClick={openModal}
                data-tooltip-id="global-tooltip"
                data-tooltip-content="Ask AI"
              >
                <i className="fas fa-robot fs-6 lh-1 text-primary"></i>
                <span className="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle notification-badge">
                  <span className="visually-hidden">Ask AI</span>
                </span>
              </div>
            </li>
            <li className="nav-item d-none">
              <NotificationDropdown></NotificationDropdown>
            </li>
            <li className="nav-item dropdown d-none">
              <a
                className="nav-link"
                id="navbarDropdownNindeDots"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                data-bs-auto-close="outside"
                aria-expanded="false"
              >
                <span
                  className="uil uil-grid fs-6 lh-1 text-white"
                  style={{ height: "20px", width: "20px" }}
                ></span>
              </a>

              <div
                className="dropdown-menu dropdown-menu-end navbar-dropdown-caret py-0 dropdown-nine-dots shadow border"
                aria-labelledby="navbarDropdownNindeDots"
              >
                <div className="card bg-body-emphasis position-relative border-0">
                  <div
                    className="card-body pt-3 px-3 pb-0 overflow-auto scrollbar"
                    style={{ height: "20rem" }}
                  >
                    <div className="row text-center align-items-center gx-0 gy-0">
                      <div className="col-4">
                        <a
                          className="d-block bg-body-secondary-hover p-2 rounded-3 text-center text-decoration-none mb-3"
                          href="#!"
                        >
                          <img
                            src={`${process.env.PUBLIC_URL}/image/nav-icons/behance.jpg`}
                            alt=""
                            width="30"
                          />
                          <p className="mb-0 text-body-emphasis text-truncate fs-10 mt-1 pt-1">
                            Behance
                          </p>
                        </a>
                      </div>
                      <div className="col-4">
                        <a
                          className="d-block bg-body-secondary-hover p-2 rounded-3 text-center text-decoration-none mb-3"
                          href="#!"
                        >
                          <img
                            src={`${process.env.PUBLIC_URL}/image/nav-icons/google-cloud.jpg`}
                            alt=""
                            width="30"
                          />
                          <p className="mb-0 text-body-emphasis text-truncate fs-10 mt-1 pt-1">
                            Cloud
                          </p>
                        </a>
                      </div>
                      <div className="col-4">
                        <a
                          className="d-block bg-body-secondary-hover p-2 rounded-3 text-center text-decoration-none mb-3"
                          href="#!"
                        >
                          <img
                            src={`${process.env.PUBLIC_URL}/image/nav-icons/slack.jpg`}
                            alt=""
                            width="30"
                          />
                          <p className="mb-0 text-body-emphasis text-truncate fs-10 mt-1 pt-1">
                            Slack
                          </p>
                        </a>
                      </div>
                      <div className="col-4">
                        <a
                          className="d-block bg-body-secondary-hover p-2 rounded-3 text-center text-decoration-none mb-3"
                          href="#!"
                        >
                          <img
                            src={`${process.env.PUBLIC_URL}/image/nav-icons/gitlab.jpg`}
                            alt=""
                            width="30"
                          />
                          <p className="mb-0 text-body-emphasis text-truncate fs-10 mt-1 pt-1">
                            Gitlab
                          </p>
                        </a>
                      </div>
                      <div className="col-4">
                        <a
                          className="d-block bg-body-secondary-hover p-2 rounded-3 text-center text-decoration-none mb-3"
                          href="#!"
                        >
                          <img
                            src={`${process.env.PUBLIC_URL}/image/nav-icons/bitbucket.jpg`}
                            alt=""
                            width="30"
                          />
                          <p className="mb-0 text-body-emphasis text-truncate fs-10 mt-1 pt-1">
                            BitBucket
                          </p>
                        </a>
                      </div>
                      <div className="col-4">
                        <a
                          className="d-block bg-body-secondary-hover p-2 rounded-3 text-center text-decoration-none mb-3"
                          href="#!"
                        >
                          <img
                            src={`${process.env.PUBLIC_URL}/image/nav-icons/google-drive.jpg`}
                            alt=""
                            width="30"
                          />
                          <p className="mb-0 text-body-emphasis text-truncate fs-10 mt-1 pt-1">
                            Drive
                          </p>
                        </a>
                      </div>
                      <div className="col-4">
                        <a
                          className="d-block bg-body-secondary-hover p-2 rounded-3 text-center text-decoration-none mb-3"
                          href="#!"
                        >
                          <img
                            src={`${process.env.PUBLIC_URL}/image/nav-icons/trello.jpg`}
                            alt=""
                            width="30"
                          />
                          <p className="mb-0 text-body-emphasis text-truncate fs-10 mt-1 pt-1">
                            Trello
                          </p>
                        </a>
                      </div>
                      <div className="col-4">
                        <a
                          className="d-block bg-body-secondary-hover p-2 rounded-3 text-center text-decoration-none mb-3"
                          href="#!"
                        >
                          <img
                            src={`${process.env.PUBLIC_URL}/image/nav-icons/figma.jpg`}
                            alt=""
                            width="20"
                          />
                          <p className="mb-0 text-body-emphasis text-truncate fs-10 mt-1 pt-1">
                            Figma
                          </p>
                        </a>
                      </div>
                      <div className="col-4">
                        <a
                          className="d-block bg-body-secondary-hover p-2 rounded-3 text-center text-decoration-none mb-3"
                          href="#!"
                        >
                          <img
                            src={`${process.env.PUBLIC_URL}/image/nav-icons/twitter.jpg`}
                            alt=""
                            width="30"
                          />
                          <p className="mb-0 text-body-emphasis text-truncate fs-10 mt-1 pt-1">
                            Twitter
                          </p>
                        </a>
                      </div>
                      <div className="col-4">
                        <a
                          className="d-block bg-body-secondary-hover p-2 rounded-3 text-center text-decoration-none mb-3"
                          href="#!"
                        >
                          <img
                            src={`${process.env.PUBLIC_URL}/image/nav-icons/pinterest.jpg`}
                            alt=""
                            width="30"
                          />
                          <p className="mb-0 text-body-emphasis text-truncate fs-10 mt-1 pt-1">
                            Pinterest
                          </p>
                        </a>
                      </div>
                      <div className="col-4">
                        <a
                          className="d-block bg-body-secondary-hover p-2 rounded-3 text-center text-decoration-none mb-3"
                          href="#!"
                        >
                          <img
                            src={`${process.env.PUBLIC_URL}/image/nav-icons/ln.jpg`}
                            alt=""
                            width="30"
                          />
                          <p className="mb-0 text-body-emphasis text-truncate fs-10 mt-1 pt-1">
                            Linkedin
                          </p>
                        </a>
                      </div>
                      <div className="col-4">
                        <a
                          className="d-block bg-body-secondary-hover p-2 rounded-3 text-center text-decoration-none mb-3"
                          href="#!"
                        >
                          <img
                            src={`${process.env.PUBLIC_URL}/image/nav-icons/google-maps.jpg`}
                            alt=""
                            width="30"
                          />
                          <p className="mb-0 text-body-emphasis text-truncate fs-10 mt-1 pt-1">
                            Maps
                          </p>
                        </a>
                      </div>
                      <div className="col-4">
                        <a
                          className="d-block bg-body-secondary-hover p-2 rounded-3 text-center text-decoration-none mb-3"
                          href="#!"
                        >
                          <img
                            src={`${process.env.PUBLIC_URL}/image/nav-icons/google-photos.jpg`}
                            alt=""
                            width="30"
                          />
                          <p className="mb-0 text-body-emphasis text-truncate fs-10 mt-1 pt-1">
                            Photos
                          </p>
                        </a>
                      </div>
                      <div className="col-4">
                        <a
                          className="d-block bg-body-secondary-hover p-2 rounded-3 text-center text-decoration-none mb-3"
                          href="#!"
                        >
                          <img
                            src={`${process.env.PUBLIC_URL}/image/nav-icons/spotify.jpg`}
                            alt=""
                            width="30"
                          />
                          <p className="mb-0 text-body-emphasis text-truncate fs-10 mt-1 pt-1">
                            Spotify
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li className="nav-item dropdown">
              <a
                className="lh-1 pe-0 overflow-hidden"
                id="navbarDropdownUser"
                href="#!"
                role="button"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <div
                  className="user-info-dropdown d-flex align-items-center gap-2"
                  style={{ maxWidth: "150px" }}
                >
                  <img
                    className="user-image rounded-circle"
                    src={avatar}
                    alt=""
                    style={{
                      width: "2.25rem",
                      height: "2.25rem",
                      border: "2px solid transparent",
                      // background:
                      //   "linear-gradient(135deg, #ff6b6b, #ffffff) border-box",
                    }}
                  />
                  <small
                    className="username fs-9 fw-bold text-dark"
                    title={localStorage.getItem("username")}
                  >
                    {localStorage.getItem("username")}
                  </small>
                  <i className="fas fa-chevron-down fs-9 text-primary"></i>
                </div>
              </a>
              <div
                className="dropdown-menu dropdown-menu-end navbar-dropdown-caret py-0 dropdown-profile shadow border"
                aria-labelledby="navbarDropdownUser"
                style={{
                  border: "1px solid #ff6b6b",
                  background: "linear-gradient(135deg, #ffffff, #fff5f5)",
                }}
              >
                <div className="card position-relative border-0">
                  <div className="card-body p-0">
                    <div className="text-center pt-4 pb-3">
                      <div className="avatar avatar-xl user-avatar-glow">
                        <img
                          className="rounded-circle border border-3 border-primary"
                          src={avatar}
                          alt=""
                        />
                      </div>
                      <h6 className="mt-2 text-body-emphasis fw-bold">
                        {localStorage.getItem("username")}
                      </h6>
                      <small className="text-muted">Welcome back!</small>
                    </div>
                  </div>
                  <div
                    className="overflow-auto scrollbar"
                    style={{ height: "10rem" }}
                  >
                    <ul className="nav d-flex flex-column mb-2 pb-1">
                      <li className="nav-item">
                        <Link
                          className="nav-link px-3 d-block"
                          to={"dashboard"}
                        >
                          <span className="me-2 text-primary align-bottom fas fa-tachometer-alt"></span>
                          <span>Dashboard</span>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link px-3 d-block"
                          to={"change-password"}
                        >
                          <span className="me-2 text-primary align-bottom fas fa-key"></span>
                          <span>Change Password</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="card-footer p-0 border-0 border-translucent">
                    <div className="px-3">
                      <button
                        className="btn btn-danger d-flex flex-center w-100 fw-bold"
                        onClick={handleLogout}
                        style={{
                          background:
                            "linear-gradient(135deg, #ff6b6b, #ff8e8e)",
                          border: "none",
                          transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.transform = "scale(1.05)";
                          e.target.style.background =
                            "linear-gradient(135deg, #ff5252, #ff7b7b)";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = "scale(1)";
                          e.target.style.background =
                            "linear-gradient(135deg, #ff6b6b, #ff8e8e)";
                        }}
                      >
                        <span className="me-2 fas fa-sign-out-alt"></span>
                        Logout
                      </button>
                    </div>
                    <div className="my-2 text-center fw-bold fs-10 text-body-quaternary">
                      <a className="text-body-quaternary me-1" href="#!">
                        Privacy Policy
                      </a>
                      •
                      <a className="text-body-quaternary mx-1" href="#!">
                        Terms
                      </a>
                      •
                      <a className="text-body-quaternary ms-1" href="#!">
                        Cookies
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default React.memo(Navbar);
